<template>
  <div class="">
    <button type="button" class="btn btn-sm btn-primary" @click="goToPDF">
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "FacturasYNCTableActions",
  methods: {
    goToPDF() {
      window.open(this.params.data.enlace);
    },
  },
});
</script>
